import { logError } from '~/logger';
import mutationPurchaseShopItem from '~/graphql/shop/mutationPurchaseShopItem';
import { ShopStoreMessage } from '../messages';
import { GameStateStore, CurrencyStore } from '~/flux/stores';

export default async function purchaseShopItem(
  {
    playerId,
    itemId,
    setShopInventory,
    setLastRestock,
    emit,
  }: {
    playerId: string;
    itemId: string;
    setShopInventory: (val: any[]) => void;
    setLastRestock: (val: number) => void;
    emit: (message: ShopStoreMessage, data?: any) => void;
  }
) {
  try {
    const result = await mutationPurchaseShopItem({ playerId, itemId });

    if (!result.success) {
      console.error('Purchase failed:', result.error);

      // Emit appropriate error events
      if (result.error === 'Insufficient pixie dust') {
        // This would need to be emitted via socket or a custom event system
        // For now, we'll log it
        console.warn('Insufficient pixie dust');
      } else if (result.error === 'Insufficient gold') {
        console.warn('Insufficient gold');
      } else if (result.error === 'No room in inventory') {
        console.warn('No room in inventory');
      }

      return;
    }

    // Update shop inventory
    if (result.shopInventory) {
      setShopInventory(result.shopInventory);
    }
    if (result.last_restock !== undefined) {
      setLastRestock(result.last_restock);
    }
    emit('SHOP_INVENTORY');

    // Update player currencies
    if (result.currency1 !== undefined || result.currency2 !== undefined) {
      CurrencyStore.updateCurrencies({
        currency1: result.currency1,
        currency2: result.currency2,
      });
    }

    // Update inventory via GameStateStore
    if (result.inventory) {
      GameStateStore.updateInventory(result.inventory);
    }
  } catch (err) {
    logError(err, {
      module: 'ShopStore',
      func: 'purchaseShopItem',
      playerId,
      itemId,
    });
  }
}
